import React from 'react';
import './App.css';

function ProjectTitle() {
  return (
    <div className="ProjectTitle">
      react-build-using-github-actions
    </div>
  );
}

export default ProjectTitle;
